import React, { useEffect, useContext, useState } from 'react';

import styled from 'styled-components';

import { saveAlerts } from '@libs/NwAlerts';
import { getMoment } from '@libs/NwMoment';
import { getNow, showLogNoTime } from '@libs/NwMoment';

import { ListContext } from '@contexts/ListContext';
import { useStateValue } from '@contexts/StateProvider';
import { UserContext } from '@contexts/UserContext';

import { useContact } from '@hooks/API/Contact/UseContact';
import useLocalStorageState from '@hooks/Utils/UseLocalStorageState';

import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const AlertWrapper = styled.div`
    margin-bottom: 1rem;
    padding: 0.5rem 3rem;
    border-radius: 1rem;
    background-color: ${(props) => props.theme.DangerColor};
    color: white;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 3rem;
    font-size: 3rem;

    .alert-content {
        flex: 1;
        h2 {
            margin: 0;
            font-size: 1.2rem;
            font-weight: 600;
            color: white;
        }
        .alert-message {
            font-size: ${(props) => props.theme.FontSizeBase};
        }
    }
    .alert-actions {
        position: relative;
        min-width: 10rem;

        span {
            align-items: baseline !important;
        }
    }
`;

const ContactAlertDrawer = ({ contactId, icon, readOnly, size, children }) => {
    const { GetUserName } = useContext(ListContext);
    const { data: currentContact } = useContact(contactId);
    const [{ areaContext }] = useStateValue();
    const [readAlerts, setReadAlerts] = useLocalStorageState(`${areaContext.area}-read-alerts`, []);
    const { currentUser } = useContext(UserContext);
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        if (currentContact && !readOnly) {
            if (currentContact.Alert) {
                if (
                    !readAlerts.find((alert) => {
                        if (
                            alert.Author === currentUser.UserID &&
                            alert.ContactID === currentContact.ID &&
                            getMoment(alert.ExpirationDate) >= getNow() &&
                            getMoment(currentContact.AlertCreationDate) <= getMoment(alert.Date)
                        ) {
                            return true;
                        }
                        return false;
                    })
                ) {
                    if (!showAlert) {
                        setShowAlert(true);
                    }
                }
            }
        }
    }, [currentContact, readOnly]);

    const handleAlerts = (alerts) => {
        setReadAlerts(alerts);
        saveAlerts(areaContext.area, alerts);
    };

    const handleDismissNotification = (key, period) => {
        setShowAlert(false);
        const findIndex = readAlerts.findIndex((alert) => {
            if (alert.Author === currentUser.UserID && alert.ContactID === currentContact.ID) {
                return true;
            }
            return false;
        });
        if (findIndex < 0) {
            handleAlerts([
                ...readAlerts,
                {
                    Author: currentUser.UserID,
                    ContactID: currentContact.ID,
                    Date: getNow(),
                    ExpirationDate: period === 'day' ? getNow().endOf('day') : getNow().add(1, period),
                },
            ]);
        } else {
            const updatedReadAlerts = [...readAlerts];
            updatedReadAlerts[findIndex] = {
                ...updatedReadAlerts[findIndex],
                Date: getNow(),
                ExpirationDate: period === 'day' ? getNow().endOf('day') : getNow().add(1, period),
            };
            handleAlerts(updatedReadAlerts);
        }
    };

    const getActions = (key) => {
        const actions = [
            {
                name: 'Mute for 7 days',
                key: 'week',
                pinned: true,
                action: () => {
                    handleDismissNotification(key, 'week');
                },
            },
            {
                name: 'Mute for today',
                type: 'day',
                key: 'day',
                action: () => {
                    handleDismissNotification(key, 'day');
                },
            },
            {
                name: 'Mute for 30 days',
                type: 'month',
                key: 'month',
                action: () => {
                    handleDismissNotification(key, 'month');
                },
            },
        ];

        return actions;
    };

    return currentContact && currentContact.Alert ? (
        <AlertWrapper>
            <NwIcon icon={byPrefixAndName.fass['message-exclamation']} />
            <div className="alert-content">
                <h2>
                    {GetUserName(currentContact.AlertUser)} {showLogNoTime(currentContact.AlertCreationDate)}
                </h2>
                <div className="alert-message">
                    <p>{currentContact.AlertMessage}</p>
                </div>
            </div>
            <div className="alert-actions">
                <NwDropDownMenu actions={getActions(`open${Date.now()}`)} />
            </div>
        </AlertWrapper>
    ) : (
        <div></div>
    );
};

//     return (!currentContact ? <div />
//         :
//             currentContact.Alert ?
//                 <>
//                     {icon ?
//                         <div onClick={handleDisplayNotification}>
//                             {icon}
//                         </div>
//                         :
//                         <BadgeRibbon
//                             size={size}
//                             color={StyleVariables.DangerColor}
//                             text={
//                                 <div className="ribbon-content" onClick={handleDisplayNotification}>
//                                     <NwIcon icon={byPrefixAndName.fass['exclamation-circle']} /> Alert
//                                 </div>
//                             }
//                             placement="start"
//                         >
//                             {children}
//                         </BadgeRibbon>
//                     }
//                 </>
//             :
//             <>
//                 {children}
//             </>
//     );
// };

export default ContactAlertDrawer;
